'use client';

interface LoadingProps {
  radius?: number;
  insideButton?: boolean;
  circleColor?: string;
  theme?: 'light' | 'dark' | 'system';
}

export default function Loading({
  radius = 64,
  insideButton = false,
  circleColor = '#000000',
  theme = 'light',
}: LoadingProps) {
  const pulseColor =
    theme === 'light' ? circleColor : '#ffffff';

  return (
    <div
      className={
        insideButton
          ? 'flex items-center justify-center'
          : 'flex items-center justify-center min-h-screen'
      }
    >
      <span
        className="relative block"
        style={{
          width: radius,
          height: radius,
        }}
      >
        <span
          className="absolute inset-0 rounded-full opacity-70"
          style={{
            backgroundColor: pulseColor,
            animation: 'doubleBounce1 2s infinite ease-in-out',
          }}
        />

        <span
          className="absolute inset-0 rounded-full opacity-70"
          style={{
            backgroundColor: pulseColor,
            animation: 'doubleBounce2 2s infinite ease-in-out',
          }}
        />
      </span>

      <style>{`
        @keyframes doubleBounce1 {
          0%, 100% {
            transform: scale(0);
          }
          50% {
            transform: scale(1);
          }
        }

        @keyframes doubleBounce2 {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(0);
          }
        }
      `}</style>
    </div>
  );
}